export default [
    {
        path: '/achievements/index',
        name: 'achievements_index',
        component: () => import('@/views/achievements/index'),
        meta: { title: "科技成果转化子平台", requireLogin: false }
    },
    {
        path: '/achievements/components/consultation',
        name: 'achievements_consultation',
        component: () => import('@/views/achievements/components/consultation'),
        meta: { title: "通知公告", requireLogin: false }
    },
    {
        path: '/achievements/components/noticeDetail',
        name: 'achievements_noticeDetail',
        component: () => import('@/views/achievements/components/noticeDetail'),
        meta: { title: "通知公告详情", requireLogin: false }
    },
    {
        path: '/achievements/components/achievement',
        name: 'achievements_achievement',
        component: () => import('@/views/achievements/components/achievement'),
        meta: { title: "基地成果", requireLogin: false }
    },
    {
        path: '/achievements/components/recruitment',
        name: 'achievements_recruitment',
        component: () => import('@/views/achievements/components/recruitment'),
        meta: { title: "科技成果", requireLogin: false }
    },
    {
        path: '/achievements/components/recruitmentDetail',
        name: 'achievements_recruitmentDetail',
        component: () => import('@/views/achievements/components/recruitmentDetail'),
        meta: { title: "科技成果详情", requireLogin: false }
    },
    {
        path: '/achievements/components/achievementDetails',
        name: 'achievements_achievementDetails',
        component: () => import('@/views/achievements/components/achievementDetails'),
        meta: { title: "企业成果详情", requireLogin: false }
    },
    {
        path: '/achievements/components/achievementRequirements',
        name: 'achievements_achievementRequirements',
        component: () => import('@/views/achievements/components/achievementRequirements'),
        meta: { title: "成果需求", requireLogin: false }
    },
    {
        path: '/achievements/components/achievementEvelutionDetail',
        name: 'achievements_achievementEvelutionDetail',
        component: () => import('@/views/achievements/components/achievementEvelutionDetail'),
        meta: { title: "成果评价详情", requireLogin: false }
    },
    {
        path: '/achievements/components/achievementEvelutionDetailNew',
        name: 'achievements_achievementEvelutionDetail',
        component: () => import('@/views/achievements/components/achievementEvelutionDetailNew'),
        meta: { title: "成果交易详情", requireLogin: false }
    },
    {
        path: '/achievements/components/corpProject',
        name: 'achievements_corpProject',
        component: () => import('@/views/achievements/components/corpProject'),
        meta: { title: "优质项目", requireLogin: false }
    },
    {
        path: '/achievements/components/corpProjectDetail',
        name: 'achievements_corpProjectDetail',
        component: () => import('@/views/achievements/components/corpProjectDetail'),
        meta: { title: "优质项目详情", requireLogin: false }
    },
    {
        path: '/achievements/components/achievementDemand',
        name: 'achievements_achievementDemand',
        component: () => import('@/views/achievements/components/achievementDemand'),
        meta: { title: "技术需求", requireLogin: false }
    },
    {
        path: '/achievements/components/achievementDemandDetail',
        name: 'achievements_achievementDemandDetail',
        component: () => import('@/views/achievements/components/achievementDemandDetail'),
        meta: { title: "技术需求详情", requireLogin: false }
    },
    {
        path: '/achievements/components/agreement',
        name: 'achievements_agreement',
        component: () => import('@/views/achievements/components/agreement'),
        meta: { title: "技术合同", requireLogin: false }
    }
]
